import React, { useRef } from 'react';

const DevelopmentalHistoryForm: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const clear = () => formRef.current?.reset();

  const milestones = [
    'Hold up head',
    'Roll Over',
    'Sit unsupported',
    'Stand alone',
    'Walk',
    'Talk',
    'Toilet Train',
    'Feed himself / herself',
    'Dress himself / herself',
  ];

  return (
    <form ref={formRef} className="family-form">
      <div className="section-title">At what age did child:</div>
      <div
        className="form-grid"
        style={{ gridTemplateColumns: 'max-content 220px', columnGap: 12, rowGap: 14 }}
      >
        {milestones.map((m, i) => (
          <React.Fragment key={m}>
            <div className="field">
              <label>{i + 1}. {m}</label>
            </div>
            <div className="field">
              <input type="text" placeholder="Age / Month" />
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="form-actions">
        <button type="button" className="btn-clear" onClick={clear}>Clear</button>
      </div>
    </form>
  );
};

export default DevelopmentalHistoryForm;


